export default {
  first_name: 'string',
  last_name: 'string',
  user_id: 'number'
}



// WEBPACK FOOTER //
// ./src/store/models/user.js